export default __webpack_public_path__ + "static/media/SIFA_NL_SEQ10.f11be415.mp3";